import React, { useState, useEffect, FC } from "react";
import toast from "react-hot-toast";
import { useAlgoSignerWalletConnector, useWalletConnector } from "./store";
import {
  WalletConnectorProps,
  WALLET_TYPES,
} from "./walletConnectorInterfaces";
import { useFoundryProvider } from "..";
import { useConnectivity } from "./useConnectivity";
// import { GasPrice } from "@cosmjs/stargate";

export const WalletConnector: FC<WalletConnectorProps> = ({
  WalletConnectView,
  WalletConnectModal,
  WalletConnectViewProps,
}: WalletConnectorProps) => {
  const [rpcUrl, setRpcUrl] = useState<string>("");
  const [showWalletDialog, setShowWalletDialog] = useState<boolean>(false);
  const {
    walletConnectionHandler,
    keplrWalletConnectionHandler,
    // algoSignerWalletConnectionHandler,
  } = useConnectivity();

  const { connectAlgorandWalletAddress } = useAlgoSignerWalletConnector();

  const { algoSignerLedger, connectors } = useFoundryProvider();

  const metaMaskClickEvent = () => {
    const { ethereum } = window as any;
    if (connectors.includes(WALLET_TYPES.META_MASK)) {
      if (!ethereum) {
        toast.error("MetaMask is not configured in your browser");
        return;
      }
      walletConnectionHandler(WALLET_TYPES.META_MASK, rpcUrl);
    } else {
      toast.error("Didn't Configured This Connector In Provider");
    }
  };

  const zerionClickEvent = () => {
    if (connectors.includes(WALLET_TYPES.ZERION)) {
      walletConnectionHandler(WALLET_TYPES.ZERION, rpcUrl);
    } else {
      toast.error("Didn't Configured This Connector In Provider");
    }
  };

  const walletConnectClickEvent = () => {
    if (connectors.includes(WALLET_TYPES.WALLET_CONNECT)) {
      walletConnectionHandler(WALLET_TYPES.WALLET_CONNECT, rpcUrl);
    } else {
      toast.error("Didn't Configured This Connector In Provider");
    }
  };

  const algorandWalletClickEvent = () => {
    if (connectors.includes(WALLET_TYPES.ALGO_SIGNER)) {
      // algoSignerWalletConnectionHandler(algoSignerLedger);
    } else {
      toast.error("Didn't Configured This Connector In Provider");
    }
  };

  const keplrWalletClickEvent = () => {
    if (connectors.includes(WALLET_TYPES.KEPLR)) {
      keplrWalletConnectionHandler();
    } else {
      toast.error("Didn't Configured This Connector In Provider");
    }
  };

  return (
    <>
      <WalletConnectView
        {...{
          ...WalletConnectViewProps,
          title: WalletConnectViewProps.title
            ? WalletConnectViewProps.title
            : "Wallet",
        }}
        onClick={() => setShowWalletDialog(true)}
      />
      <WalletConnectModal
        show={showWalletDialog}
        metaMaskClickEvent={metaMaskClickEvent}
        walletConnectClickEvent={walletConnectClickEvent}
        algorandWalletClickEvent={algorandWalletClickEvent}
        keplrWalletClickEvent={keplrWalletClickEvent}
        zerionClickEvent={zerionClickEvent}
        selectNetworkRPC={(value: string) => {
          setRpcUrl(value);
        }}
        selectAlgorandWalletAddress={(value: string) =>
          connectAlgorandWalletAddress(value)
        }
        onHide={() => setShowWalletDialog(false)}
      />
    </>
  );
};
